import React, { Component } from 'react';
import { urlApi } from '../Constants/Global';
import { SectionNavbar, SectionCarousel, SectionAbout, SectionService, SectionContact, Footer, Copyright, SectionNavbarCorner } from '../Components';
import logo from '../Images/logo/logo.webp';
import SectionCertify from '../Components/SectionCertify';
import SectionWhy from '../Components/SectionWhy';
import SectionProduct from '../Components/SectionProduct';

export class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTemporary: false,
      contents: {
        lang: 'th', 
        popup_pdpa: false, 
        contact: {
          address: '17/3 หมู่ 9 ถนนจันทร์ทองเอี่ยม ตำบลบางแม่นาง อำเภอบางใหญ่ นนทบุรี 11140',
          phone: '086-988-4525',
          email: 'md.ktn.plaspack@gmail.com', 
          facebook: '', 
          line: '', 
          linelink: 'https://line.com'
        }, 
        slides: [], 
        certifies: [], 
        services: [], 
        whys: [], 
        products: [], 
        about: {
          item: {
            name: '', 
            detail: '', 
            row_value: ''
          }, 
          contents: []
        }
      }
    }
  }

  async componentDidMount() {
    console.log("componentDidMount", urlApi + "/?module=home&call=get-content");
    const url = urlApi + "/?module=home&call=get-content";
    await fetch(url)
      .then(res => res.json())
      .then(result => {
        console.log("App", result);
        this.setState({ contents: result.results });
      });
  }

  render() {
    return (
      <>
        <div className="design-2-2">
          <SectionNavbar logo={logo} lang={this.state.contents.lang} />
          <SectionCarousel lang={this.state.contents.lang} contents={this.state.contents.slides} />
          <SectionCertify contents={this.state.contents.certifies} />
          <SectionWhy contents={this.state.contents.whys} />
          <SectionService contents={this.state.contents.services} />
          <SectionAbout contents={this.state.contents.about} />
          <SectionProduct contents={this.state.contents.products} />
          <SectionContact 
            address={this.state.contents.contact.address}
            line={this.state.contents.contact.line} 
            linelink={this.state.contents.contact.linelink} 
            phone={this.state.contents.contact.phone} 
            email={this.state.contents.contact.email} 
            facebook={this.state.contents.contact.facebook} 
            messenger={this.state.contents.contact.messenger} 
            googlemaps={this.state.contents.contact["google-maps"]} 
            />
          <Footer lang={this.state.contents.lang} />
          <Copyright lang={this.state.contents.lang} />
          <SectionNavbarCorner/>
        </div>
      </>
    )
  }
}

export default Home